import React from 'react'
import { generateMonClubUrlByExtId } from '../../shared/competitionUrls'
import style from './style.module.scss'
import clsx from 'clsx'

interface MonClubLinkProps extends React.PropsWithChildren {
    extStructureId: number
    className?: string
    disableLink?: boolean
}

export const MonClubLink: React.FC<MonClubLinkProps> = ({
    children,
    extStructureId,
    className,
    disableLink = false,
}) => {
    if (disableLink) {
        return <span className={clsx(style.link, style.span, className)}>{children}</span>
    }

    return (
        <a
            href={generateMonClubUrlByExtId(extStructureId)}
            target="_blank"
            rel="noreferrer"
            className={clsx(style.link, className)}
        >
            {children}
        </a>
    )
}
